import { Button } from '@breetometer/components';
import { useCallback } from 'react';

import type { ITabHeader } from '../Tab.helpers';

const TabHeaderDefault = <T extends string>({ tabs, onTabClick, setActiveTab, activeTab }: ITabHeader<T>) => {
	const handleTabClick = useCallback(
		(tabItem: T) => () => {
			onTabClick?.(tabItem);
			setActiveTab(tabItem);
		},
		[onTabClick, setActiveTab]
	);

	const buttonClass = (tabItem: string) =>
		`tab_header_button${activeTab === tabItem ? ' active bg-primary-400' : ' color-primary-300 border-bottom-primary-400'}`;

	return (
		<div className='tab_header'>
			{tabs.map((tabItem) => (
				<Button
					variant='native'
					key={tabItem}
					type='button'
					className={buttonClass(tabItem)}
					onClick={handleTabClick(tabItem as T)}
				>
					{tabItem}
				</Button>
			))}
		</div>
	);
};

export default TabHeaderDefault;
